<div class="toggle-config">
  <label class="switch">
    <input
      [checked]="isChecked"
      [attr.id]="internalId"
      type="checkbox"
      value="isChecked"
      (change)="onToggleChange()">
    <span class="slider round"></span>
  </label>
  <label [for]="internalId"
         class="toggle-label"
         [ngbTooltip]="labelTooltip ? labelTooltip : ''"
  >
    {{ toggleLabel }}
  </label>
</div>
